import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonItem } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const AddDiscussionVideoLessonsSlice = createSlice({
  name: "AddDiscussionVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    AddDiscussionVideoLesson: (state, action) => {
      state.isLoading = true;
    },

    successAddDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureAddDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  AddDiscussionVideoLesson,
  successAddDiscussionVideoLessons,
  failureAddDiscussionVideoLessons,
} = AddDiscussionVideoLessonsSlice.actions;

export default AddDiscussionVideoLessonsSlice.reducer;
